// src/pages/Customer/ProjectDetail.jsx
import React, { useState } from "react";
import Layout from "../../layout/customer/Layout";
import MasterDataDisplay from "../../layout/common/MasterDataDisplay";
import DocumentUploadReq from "../Builders/DocumentUploadReq";
import { ArrowLeft, CreditCard } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";

const ProjectDetail = () => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [activeTab, setActiveTab] = useState("master-data");

  const handleGoBack = () => navigate(-1);

  const handleTabClick = (tabId) => {
    if (tabId === "finances") {
      // Navigate to the payment page instead of embedding the component
      navigate(`/customer/project/${projectId}/payment`);
      return;
    }
    setActiveTab(tabId);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "master-data":
        return <MasterDataDisplay projectId={projectId} />;
      case "docs":
        return <DocumentUploadReq />;
      default:
        return <MasterDataDisplay projectId={projectId} />;
    }
  };

  const tabItems = [
    {
      id: "master-data",
      label: "Master Data",
    },
    {
      id: "finances",
      label: "Finances",
      icon: <CreditCard className="w-4 h-4 mr-1.5 sm:mr-2" />,
    },
    {
      id: "docs",
      label: "Docs",
    },
  ];

  return (
    <Layout>
      <div className="h-full flex flex-col bg-gray-50 rounded-lg shadow-md">
        <div className="px-3 lg:px-4 sm:px-6 py-3 border-b border-gray-200 bg-white rounded-t-lg flex-shrink-0 flex items-center sticky top-0 z-20 shadow-sm">
          <button
            onClick={handleGoBack}
            className="p-1.5 mr-2 sm:mr-3 text-gray-500 hover:text-blue-600 hover:bg-gray-100 rounded-full transition-colors duration-150"
            aria-label="Go back"
          >
            <ArrowLeft className="w-4 h-4 lg:w-5 lg:h-5" />
          </button>
          <h2 className="text-sm lg:text-base sm:text-lg font-semibold text-gray-800 flex items-center">
            Project Overview (ID: {projectId})
          </h2>
        </div>

        <div className="px-3 lg:px-4 sm:px-6 border-b border-gray-200 bg-white flex-shrink-0">
          <nav
            className="-mb-px flex space-x-2 lg:space-x-3 sm:space-x-4 overflow-x-auto pb-px"
            aria-label="Tabs"
          >
            {tabItems.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className={`whitespace-nowrap py-2 lg:py-2.5 px-1 border-b-2 font-medium text-xs lg:text-sm flex items-center transition-colors duration-200 focus:outline-none
                  ${
                    activeTab === tab.id
                      ? "border-blue-500 text-blue-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
              >
                {tab.icon}
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="flex-grow overflow-y-auto p-3 lg:p-4 sm:p-6">
          {renderTabContent()}
        </div>
      </div>
    </Layout>
  );
};

export default ProjectDetail; 